module.exports = __webpack_public_path__ + "static/media/AB_O1_17.a83ed5b7.jpg";